<template>
  <entity-select-dialog
      ref="entitySelectDialog"
      :search="search"
      :items="items"
      :loading="loading">

    <template v-slot:listItem="props">
      <part-list-item :item="props.item"
                        :row-click-enabled="true"
                        :showActions="false"/>

    </template>
  </entity-select-dialog>
</template>

<script>
import PartsService from '@/services/PartsService';
import PartListItem from '@/views/parts/PartListItem';
import EntitySelectDialog from '@/components/entity-crud/EntitySelectDialog';

export default {
  name: 'PartSelectDialog',
  components: { EntitySelectDialog, PartListItem },

  data: () => ({
    items: [],
    loading: false,
  }),

  methods: {

    selectedEntity(part) {
      this.$emit('selected', part);
      this.close();
    },

    show() {
      this.$refs.entitySelectDialog.show();

    },

    close() {
      this.$refs.entitySelectDialog.close();
    },

    mapToItem(part){
      return {
        part: part,
        rowClick: () => {
          this.selectedEntity(part);
        },
      };
    },
    search(searchTerm) {
      if (!searchTerm) {
        searchTerm = null;
      }

      this.items = [];
      this.loading = true;
      PartsService.findPartsByNameOrIdentification(searchTerm).then(result => {
        this.items = result.data.map(this.mapToItem);
      }).catch(err => {
        console.log(err);
      }).finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>

</style>
